import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AddNewsPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminNews : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/news'; // API endpoint for creating product
  const successRedirect = '/admin/News'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};

export default AddNewsPage;
